const CAPITA_EXP = {
    duration: 'April \'19 - Present',
    designation: 'Senior Software Consultant',
    company: 'Capita',
    onContract: false,
    isPermanent: true,
    summary: `
    <li>- Develop reusable, scalable components using React JS</li>
    <li>- Define and maintain a good code repository structure </li>
    <li>- Fix security vulnerabilities reported by Veracode and WhiteSource</li>
    <li>- Set processes to ensure smooth workflow</li>
    <li>- Review pull requests</li>
    `
};

const AMDOCS_EXP = {
    duration: 'Nov \'16 - April \'19',
    designation: 'Software Engineer - Experienced',
    company: 'Amdocs (Vendor: Infovision Labs)',
    onContract: true,
    contractInfo: {
        vendor: 'Infovision Labs',
        duration: 'Nov \'16 - Sep \'19'
    },
    isPermanent: true,
    summary: `
    <li>- Deliver MVP to the customer using extreme programming</li>
    <li>- Design, develop and deliver complex widgets using React, Redux</li>
    <li>- Modify and develop REST APIs using spring</li>
    <li>- Do code review to maintain healthy code base</li>
    <li>- Add new & reusable features to core product</li>
    <li>- Fix integration bugs/defects by discussing precise solutions with external apps</li>
    `
};

const CS_EXP = {
    duration: 'Apr \'16 - Nov \'16',
    designation: 'Software Developer',
    company: 'ContentSphere Technologies',
    onContract: false,
    isPermanent: true,
    summary: `
    <li>- Deliver high quality components iteratively using PHP, JS & CSS</li>
    <li>- Add robust, scalable building blocks to new version of core product</li>
    <li>- Handle deployment on client environments</li>
    <li>- Improve performance of existing components</li>
    <li>- Fix production and integration bugs/defects</li>
    `
};

const TRIBBIANIS_EXP = {
    duration: 'Aug \'15 - Apr \'16',
    designation: 'Software Engineer',
    company: 'Tribiannis Software Solutions Pvt Ltd.',
    onContract: false,
    isPermanent: true,
    summary: `
    <li>- Analyze and provide estiamtions for client requirements</li>
    <li>- Design and develop modules using JSP, Servlets</li>
    <li>- Write REST APIs for UI modules</li>
    `
};


export {
    CAPITA_EXP,
    AMDOCS_EXP,
    CS_EXP,
    TRIBBIANIS_EXP
};